import {SvgIconData} from '@shared_web/components/core/svg_icon';

export const icon_ruler_horizontal: SvgIconData = {
  viewBox: '0 30.61 100 40.29',
  element: (
    <path d="M0 70.9h100V46.16H0zm3-21.73h2.48v6.1h3v-6.1h3.62v6.1h3v-6.1h3.61v12.31h3v-12.3h3.62v6.1h3v-6.1h3.62v6.1h3v-6.1h3.62v12.3h3v-12.3h3.62v6.1h3v-6.1h3.62v6.1h3v-6.1h3.62v12.3h3v-12.3h3.61v6.1h3v-6.1h3.62v6.1h3v-6.1h3.62v12.3h3v-12.3h3.62v6.1h3v-6.1h3.62v6.1h3v-6.1H97v18.71H3zM97 30.6v3.31H3v-3.3H0v9.6h3v-3.3h94v3.3h3v-9.6z" />
  ),
};
